import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["header", "panelKey", "headerClass", "headerWrapperClass", "arrowClass", "arrowSize", "showArrow", "forceRender", "headerPrefix"],
  _excluded2 = ["key", "header", "showDefaultArrow", "showArrow", "body", "disabled", "headerClass", "headerWrapperClass", "arrowClass", "arrowSize", "headerPrefix"],
  _excluded3 = ["children", "bordered", "accordion"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Collapse } from 'antd';
import _noop from 'lodash/noop';
import _size from 'lodash/size';
import _get from 'lodash/get';
import _head from 'lodash/head';
import _castArray from 'lodash/castArray';
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import FontIcon, { SIZES } from '../../atoms/FontIcon';
import Heading from '../../atoms/Heading';
import styles from './collapse.module.scss';
import './collapse.antd.scss';
var EXPANDED_ICON = 'icon-caret-down';
var COLLAPSED_ICON = 'icon-caret-right';
var Panel = Collapse.Panel;

/*
As a default behaviour if children or panel only has one entry & defaultExpand prop is true, then
we don't show collapsed view instead we auto populate that view
*/
var getDefaultActiveKey = function getDefaultActiveKey(_ref) {
  var defaultActiveKey = _ref.defaultActiveKey,
    children = _ref.children,
    panels = _ref.panels,
    _ref$defaultExpand = _ref.defaultExpand,
    defaultExpand = _ref$defaultExpand === void 0 ? true : _ref$defaultExpand;
  if (_size(defaultActiveKey)) return defaultActiveKey;
  if (_size(children) === 1 && defaultExpand) return _get(_head(children), 'props.panelKey');
  if (_size(panels) === 1 && defaultExpand) return _get(_head(panels), 'key');
  return undefined;
};
var CollapseAnt = /*#__PURE__*/function (_PureComponent) {
  _inherits(CollapseAnt, _PureComponent);
  var _super = _createSuper(CollapseAnt);
  function CollapseAnt(_props) {
    var _this;
    _classCallCheck(this, CollapseAnt);
    _this = _super.call(this, _props);
    _defineProperty(_assertThisInitialized(_this), "getIcon", function (panelKey) {
      var activePanel = _this.state.activePanel;
      if (activePanel.includes("".concat(panelKey))) {
        return EXPANDED_ICON;
      }
      return COLLAPSED_ICON;
    });
    _defineProperty(_assertThisInitialized(_this), "renderDraggableIcon", function () {
      var dragIconClassName = _this.props.dragIconClassName;
      return /*#__PURE__*/React.createElement(FontIcon, {
        className: "".concat(styles.dragIcon, " ").concat(dragIconClassName)
      }, "icon-drag-and-drop");
    });
    _defineProperty(_assertThisInitialized(_this), "renderHeader", function (headerComponent, panelKey) {
      var headerClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var headerWrapperClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var arrowClass = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
      var arrowSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : SIZES.MD;
      var showArrow = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
      var showDraggableCss = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
      var headerPrefix = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
      var collapseHeaderClassName = _this.props.collapseHeaderClassName;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.collapseHeaderWrapper, " ").concat(collapseHeaderClassName, " ").concat(headerWrapperClass)
      }, showDraggableCss && _this.renderDraggableIcon(), headerPrefix, showArrow && /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.arrowIcon, " ").concat(arrowClass)
      }, /*#__PURE__*/React.createElement(FontIcon, {
        color: "black",
        size: arrowSize,
        className: styles.jobIssue
      }, _this.getIcon(panelKey))), /*#__PURE__*/React.createElement("div", {
        className: cx(styles.collapseHeader, !showArrow && styles.noArrow, headerClass)
      }, /*#__PURE__*/React.isValidElement(headerComponent) ? headerComponent : /*#__PURE__*/React.createElement(Heading, {
        size: 4
      }, headerComponent)));
    });
    _defineProperty(_assertThisInitialized(_this), "renderBody", function (bodyComponent) {
      var bodyClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.collapseBody, " ").concat(bodyClassName)
      }, bodyComponent);
    });
    _defineProperty(_assertThisInitialized(_this), "renderChildren", function () {
      var _this$props = _this.props,
        children = _this$props.children,
        bodyClassName = _this$props.bodyClassName,
        showDraggableCss = _this$props.showDraggableCss;
      var childrenToIterate = children.constructor === Array ? children : [children];
      return childrenToIterate.map(function (_ref2) {
        var props = _ref2.props;
        var header = props.header,
          panelKey = props.panelKey,
          headerClass = props.headerClass,
          headerWrapperClass = props.headerWrapperClass,
          arrowClass = props.arrowClass,
          arrowSize = props.arrowSize,
          showArrow = props.showArrow,
          forceRender = props.forceRender,
          headerPrefix = props.headerPrefix,
          rest = _objectWithoutProperties(props, _excluded);
        return /*#__PURE__*/React.createElement(Panel, _extends({
          showArrow: false,
          header: _this.renderHeader(header, panelKey, headerClass, headerWrapperClass, arrowClass, arrowSize, showArrow, showDraggableCss, headerPrefix),
          key: panelKey,
          forceRender: forceRender,
          id: "automation_selector_collapsible_panel_".concat(panelKey)
        }, rest), _this.renderBody(props.children, bodyClassName));
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderPanel", function () {
      var _this$props2 = _this.props,
        panels = _this$props2.panels,
        bodyClassName = _this$props2.bodyClassName,
        showDraggableCss = _this$props2.showDraggableCss;
      return panels.map(function (_ref3) {
        var key = _ref3.key,
          header = _ref3.header,
          _ref3$showDefaultArro = _ref3.showDefaultArrow,
          showDefaultArrow = _ref3$showDefaultArro === void 0 ? false : _ref3$showDefaultArro,
          showArrow = _ref3.showArrow,
          body = _ref3.body,
          disabled = _ref3.disabled,
          headerClass = _ref3.headerClass,
          headerWrapperClass = _ref3.headerWrapperClass,
          arrowClass = _ref3.arrowClass,
          arrowSize = _ref3.arrowSize,
          headerPrefix = _ref3.headerPrefix,
          rest = _objectWithoutProperties(_ref3, _excluded2);
        return /*#__PURE__*/React.createElement(Panel, _extends({
          showArrow: showDefaultArrow,
          key: key,
          header: _this.renderHeader(header, key, headerClass, headerWrapperClass, arrowClass, arrowSize, showArrow, showDraggableCss, headerPrefix),
          disabled: disabled
        }, rest), _this.renderBody(body, bodyClassName));
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onChangePanel", function () {
      var panelKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
      var onChange = _this.props.onChange;
      _this.setState({
        activePanel: _toConsumableArray(panelKey)
      }, onChange(panelKey));
    });
    var defaultActiveKey = getDefaultActiveKey(_props);
    _this.state = {
      activePanel: _castArray(defaultActiveKey),
      defaultActiveKey: defaultActiveKey
    };
    return _this;
  }
  _createClass(CollapseAnt, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        children = _this$props3.children,
        bordered = _this$props3.bordered,
        accordion = _this$props3.accordion,
        restProps = _objectWithoutProperties(_this$props3, _excluded3);
      var defaultActiveKey = this.state.defaultActiveKey;
      return /*#__PURE__*/React.createElement(Collapse, _extends({}, restProps, {
        accordion: accordion,
        bordered: bordered,
        defaultActiveKey: defaultActiveKey,
        onChange: this.onChangePanel
      }), children ? this.renderChildren() : this.renderPanel());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, nextState) {
      var activePanel = nextProps.activeKey;
      var defaultActiveKey = getDefaultActiveKey(nextProps);
      if (defaultActiveKey !== nextState.defaultActiveKey) {
        return {
          activePanel: _castArray(defaultActiveKey),
          defaultActiveKey: defaultActiveKey
        };
      }
      /**
       * needed for cases like empty array, > 1 items in array
       */
      if (activePanel) return {
        activePanel: activePanel
      };
      return null;
    }
  }]);
  return CollapseAnt;
}(PureComponent);
_defineProperty(CollapseAnt, "propTypes", {
  defaultActiveKey: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  panels: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.node,
    body: PropTypes.node,
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    headerClass: PropTypes.string,
    arrowClass: PropTypes.string,
    disabled: PropTypes.bool,
    arrowSize: PropTypes.string
  })),
  children: PropTypes.node,
  bordered: PropTypes.bool,
  accordion: PropTypes.bool,
  bodyClassName: PropTypes.string,
  defaultExpand: PropTypes.bool,
  showDraggableCss: PropTypes.bool,
  collapseHeaderClassName: PropTypes.string,
  dragIconClassName: PropTypes.string
});
_defineProperty(CollapseAnt, "defaultProps", {
  onChange: _noop,
  defaultActiveKey: EMPTY_ARRAY,
  panels: EMPTY_ARRAY,
  children: null,
  bordered: false,
  accordion: false,
  bodyClassName: '',
  defaultExpand: true,
  showDraggableCss: false,
  collapseHeaderClassName: '',
  dragIconClassName: ''
});
_defineProperty(CollapseAnt, "Panel", Panel);
export { CollapseAnt as default };